export default "__VITE_ASSET__CcWWDEDY__"